import { gql } from '@apollo/client';

export const GET_TMS_TASK_DETAIL = gql`
    query GetTmsTaskDetail($taskId: ID!) {
        task: getTmsTaskByIdForPortal(id: $taskId) {
            id
            taskNumber
            taskType
            businessType
            taskDate
            taskStatus
            routeId
            routeName
            routeType
            carrierSourceType
            warehouseId
            planDepartureTime
            carrierId
            carrierName
            driver1Id
            driver1Name
            driver1PhoneNumber
            driver2Id
            driver2Name
            driver2PhoneNumber
            isBulkConsolidated
            vehicleId
            licensePlate
            vehicleModelId
            vehicleTypeId
            vehicleTypeName
            trailerNumber
            remark
            cancelReason
            escortCount
            gpsTracking
            perVehicleCost
            publishedAt
            completedAt
            warehouseOperationSimplify
        }
        waypoints: getTmsTaskWaypointDetailInfoByTaskId(taskId: $taskId) {
            id
            taskId
            waypointId
            routeId
            planDepartureAt
            planDepartureTimezone
            actualDepartureAt
            actualDepartureTimezone
            departureRemark
            planArrivalDate
            planArrivalTime
            planArrivalAt
            planArrivalTimezone
            actualArrivalAt
            actualArrivalTimezone
            staticEtaDate
            staticEtaTime
            staticEtaAt
            staticEtaTimezone
            arrivedRemark
            waypointStatus
            waypointOrder
            waypointType
            loadingTime
            loadingTimeTimezone
            unLoadingTime
            unLoadingTimeTimezone
            loadingInfoRemark
            loadingInfoInteriorPhotosJson
            loadingInfoInteriorPhotosUrlsJson
            parcelCount
            bagCount
            sealNumber
            sealTime
            sealTimeTimezone
            unSealTime
            unSealTimeTimezone
            unSealNumber
            unSealInteriorPhotosJson
            unSealInteriorPhotosUrlsJson
            arrivalPhotosJson
            arrivalPhotosUrlsJson
            arrivalSealPhotosJson
            arrivalSealPhotosUrlsJson
            departurePhotosJson
            departurePhotosUrlsJson
            departureSealPhotosJson
            departureSealPhotosUrlsJson
            bolRemark
            bolPhotosJson
            bolPhotosUrlsJson
            waypointSortingCode
            containerInfo {
                containerSource
                destinationWarehouseId
                destinationWarehouseSortingCode
                siteType
                containerTypes {
                    containerType
                    containerCount
                }
            }
        }
        exceptions: getTmsExceptionsByTaskId(taskId: $taskId) {
            id
            taskId
            exceptionReasonType
            location
            remark
            exceptionPhotosJson
            exceptionPhotosUrlsJson
            createdAt
            updatedAt
        }
        transitInfos: getTmsTaskTransitInfosByTaskId(taskId: $taskId) {
            id
            transitWarehouseId
            transitDestWarehouseId
            destLoaded
            destUnloaded
        }
    }
`;

export interface TmsTaskWaypointType {
    id: string;
    taskId: number;
    waypointId: number;
    routeId: number;
    planDepartureDate?: string | null;
    planDepartureTime?: string | null;
    planDepartureAt?: string | null;
    planDepartureTimezone?: string | null;
    actualDepartureDate?: string | null;
    actualDepartureTime?: string | null;
    actualDepartureAt?: string | null;
    actualDepartureTimezone?: string | null;
    departureRemark?: string | null;
    planArrivalDate?: string | null;
    planArrivalTime?: string | null;
    planArrivalAt?: string | null;
    planArrivalTimezone?: string | null;
    actualArrivalDate?: string | null;
    actualArrivalTime?: string | null;
    actualArrivalAt?: string | null;
    actualArrivalTimezone?: string | null;
    staticEtaDate?: string | null;
    staticEtaTime?: string | null;
    staticEtaAt?: string | null;
    staticEtaTimezone?: string | null;
    arrivedRemark?: string | null;
    waypointStatus: number;
    waypointOrder: number;
    waypointType: number;
    loadingTime?: string | null;
    loadingTimeTimezone?: string | null;
    unLoadingTime?: string | null;
    unLoadingTimeTimezone?: string | null;
    loadingInfoRemark?: string | null;
    loadingInfoInteriorPhotosJson?: string[] | null;
    loadingInfoInteriorPhotosUrlsJson?: string[];
    parcelCount: number;
    bagCount: number;
    sealNumber?: string | null;
    sealTime?: string | null;
    sealTimeTimezone?: string;
    unSealTime?: string | null;
    unSealTimeTimezone?: string;
    unSealNumber?: string | null;
    unSealInteriorPhotosJson?: string[] | null;
    unSealInteriorPhotosUrlsJson?: string[];
    arrivalPhotosJson?: string[] | null;
    arrivalPhotosUrlsJson?: string[];
    arrivalSealPhotosJson?: string[] | null;
    arrivalSealPhotosUrlsJson?: string[];
    departurePhotosJson?: string[] | null;
    departurePhotosUrlsJson?: string[];
    departureSealPhotosJson?: string[] | null;
    departureSealPhotosUrlsJson?: string[];
    bolRemark?: string | null;
    bolPhotosJson?: string[] | null;
    bolPhotosUrlsJson?: string[] | null;
    waypointSortingCode?: string | null;
    containerInfo?: TmsTaskContainerInfoGroupType[] | null;
    createdAt?: string | null;
    updatedAt?: string | null;
}

export interface TmsTaskContainerInfoGroupType {
    containerSource: number;
    destinationWarehouseId: number;
    destinationWarehouseSortingCode?: string | null;
    siteType?: number | null;
    containerTypes: TmsTaskContainerInfoItemType[];
}

export interface TmsTaskContainerInfoItemType {
    containerType: number;
    containerCount: number;
}

export interface TmsExceptionType {
    id: string;
    taskId: number;
    exceptionReasonType: number;
    location: string;
    remark?: string | null;
    exceptionPhotosJson: string[];
    exceptionPhotosUrlsJson: string[];
    createdAt?: string | null;
    updatedAt?: string | null;
}

export interface TmsTaskDetailType {
    id: string;
    taskNumber: string;
    taskType: number;
    businessType: number;
    taskDate: string;
    taskStatus: number;
    routeId: number;
    routeName: string;
    routeType?: number;
    carrierSourceType?: number;
    warehouseId: number;
    planDepartureDate?: string;
    planDepartureTime?: string;
    actualDepartureDate?: string;
    actualDepartureTime?: string;
    actualDepartureAt?: string;
    planArrivalDate?: string;
    planArrivalTime?: string;
    actualArrivalDate?: string;
    actualArrivalTime?: string;
    actualArrivalAt?: string;
    carrierId: number;
    carrierName?: string;
    driver1Id?: number | null;
    driver1Name?: string | null;
    driver1PhoneNumber?: string | null;
    // 司机2：非必填，仅BOL展示
    driver2Id?: number | null;
    driver2Name?: string | null;
    driver2PhoneNumber?: string | null;
    isBulkConsolidated?: boolean | null;
    vehicleId: number;
    licensePlate?: string;
    vehicleModelId?: number | null;
    vehicleTypeId?: number | null;
    vehicleTypeName?: string | null;
    trailerNumber?: string | null;
    remark?: string | null;
    // 取消原因：PC 取消任务时填写，仅已取消任务有值
    cancelReason?: string | null;
    escortCount?: number | null;
    gpsTracking?: string | null;
    perVehicleCost: number;
    publishedAt?: string;
    completedAt?: string;
    // 是否命中仓库操作简化（后端按 common_config 判定）：命中时途经点仅到达/发车、终点仅到达
    warehouseOperationSimplify?: boolean | null;
    createdAt?: string;
    updatedAt?: string;
}

export interface TmsTaskTransitInfoType {
    id: string;
    transitWarehouseId?: number | null;
    transitDestWarehouseId?: number | null;
    /** 转运目的地站是否已有装车数据：true 时该行锁定（目的地站不可改/删，转运站仅可改为未发车站） */
    destLoaded?: boolean;
    /** 转运货物是否已卸车：true 时该行消费完毕，整行冻结（目的地站与转运站均不可改/删） */
    destUnloaded?: boolean;
}

export interface GetTmsTaskDetailResponse {
    task: TmsTaskDetailType | null;
    waypoints: TmsTaskWaypointType[];
    exceptions: TmsExceptionType[];
    transitInfos: TmsTaskTransitInfoType[];
}

export interface GetTmsTaskDetailVariables {
    taskId: string;
}

